import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { ConfirmHost } from '@/components/ui/confirm';
import { Toaster } from '@/components/ui/toast';
import { NotFound } from './-not-found';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  notFoundComponent: NotFound,
});

function Root() {
  return (
    <>
      <Outlet />
      <Toaster />
      <ConfirmHost />
    </>
  );
}
